import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardFooter } from '../../components/CardFooter';
import { NavCategory } from '../../enums/NavCategory.enum';
import { NavCategoryContext } from '../../enums/NavCategoryContext.enum';
import { SelectionType } from '../../enums/SelectionType.enum';
import { navCategorySets, useNavCategories } from '../../hooks/actions/useNavCategories';
import { useProductSelection } from '../../hooks/useProductSelection';
import { isMobileState } from '../../recoil/selectors';
import { ProductDetailPageDesktop } from './ProductDetailPageDesktop';
import { ProductDetailPageMobile } from './ProductDetailPageMobile';
import ProductDetailSchema from './ProductDetailSchema';

export const ProductDetailLander: React.FC = () => {
  const { product } = useProductSelection(SelectionType.ProductSection, '0');
  const isMobile = useRecoilValue(isMobileState);
  useNavCategories({ context: NavCategoryContext.LandingPage, initializeCategory: NavCategory.Bestsellers });

  const firstApplicableCollection = navCategorySets.find(
    (nav) => nav.navCategory !== NavCategory.All && nav.productTags.some((pt) => product.tags.includes(pt)),
  );

  const breadCrumbs = firstApplicableCollection
    ? [
        { title: 'All', link: '/products' },
        { title: firstApplicableCollection.title, link: firstApplicableCollection.link },
      ]
    : [{ title: 'All', link: '/products' }, { title: product.title }];

  return (
    <>
      <ProductDetailSchema />
      {isMobile && (
        <>
          <ProductDetailPageMobile breadCrumbs={breadCrumbs} />
          <CardFooter />
        </>
      )}
      {!isMobile && (
        <>
          <ProductDetailPageDesktop breadCrumbs={breadCrumbs} />
          <CardFooter />
        </>
      )}
    </>
  );
};

export default ProductDetailLander;
